export default "__VITE_ASSET__d_1f0Mho__"